import { AxiosInterceptor } from "api/core/consts";

export const bookmark = {
  accountBookmark: (accountId) => AxiosInterceptor.get('account/bookMark/' + accountId),
  elementBookmark: (elementId) => AxiosInterceptor.get('element/bookMark/' + elementId),
  processBookmark: (processId) => AxiosInterceptor.get('process/bookMark/' + processId),
  workOrderBookmark: (workOrderId) => AxiosInterceptor.get('workOrder/bookMark/' + workOrderId),
};
